import { render, staticRenderFns } from "./Carrito.vue?vue&type=template&id=7ca54545"
import script from "./Carrito.vue?vue&type=script&lang=ts"
export * from "./Carrito.vue?vue&type=script&lang=ts"
import style0 from "./Carrito.vue?vue&type=style&index=0&id=7ca54545&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports